import reset_password from '../modules/auth/pages/reset-password/routes';
import auth from "../modules/auth/routes";
import brands from "../modules/brands/routes";
import dashboard from "../modules/dashboard/routes";
import mortgage from "../modules/mortgage/routes";
import reservation from "../modules/reservation/routes";
import resources from "../modules/resources/routes";

export default [
  ...auth,
  ...reset_password,
  ...dashboard,
  ...mortgage,
  ...brands,
  ...reservation,
  ...resources
];
